import { render, staticRenderFns } from "./threeBigShelf.vue?vue&type=template&id=66f163ff&scoped=true&"
import script from "./threeBigShelf.vue?vue&type=script&lang=js&"
export * from "./threeBigShelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f163ff",
  null
  
)

export default component.exports